import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import vw from 'src/styles/utils';
// Uncomment for phase 2
// import Back from 'components/Back';
import Button from 'components/Button';
import Loading from 'components/Loading';
import Helmet from 'react-helmet';

import { setPerson, setEmail,setProfile } from 'src/redux/registrant';
import { getSearchUser,setInteraction } from 'src/scripts/requests';

import { vwTablet } from 'src/styles/utils';
import media from 'src/styles/media';

const Email = () => {
  const [email, setEmailState] = useState(null);
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams();

  const validateEmail = (email) => {
    const rgx =
      // eslint-disable-next-line no-useless-escape
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (rgx.test(String(email).toLowerCase())) {
      setIsEmailValid(true);
      setEmailState(email);
    } else {
      setIsEmailValid(false);
      setEmailState(null);
    }
  };

function diclosureRequirements(obj) {
  
  if(obj === undefined){
    return false
  }
//   var obj = {
//     "19535598": {
//         "key": "DRUP",
//         "value": "November 3, 2021",
//         "created_at": "2021-11-04T04:14:43.537Z",
//         "updated_at": "2021-11-04T04:14:43.537Z",
//         "dynamic_attribute_id": 4720
//     },
//     "19535599": {
//         "key": "DRTS",
//         "value": "November 3, 2021",
//         "created_at": "2021-11-04T04:14:43.562Z",
//         "updated_at": "2021-11-04T04:14:43.562Z",
//         "dynamic_attribute_id": 4719
//     }
// };
  
  
  // Object.keys(obj).forEach(function(key) {
  //   Object.keys(key).forEach(function(key2) {
  //     console.log(key2)
  //   })
   
  // })
  
  let DRTS = false;
  let DRUP = false;

  for (const [key, value] of Object.entries(obj)) {
    for (const [key2, value2] of Object.entries(value)) {
      if(value2 == "DRTS"){
        DRTS = true;
      }
      if(value2 == "DRUP"){
        DRUP = true;
      }
      if(DRTS & DRUP){
        return true;
      }
    }
   
  }

}




  const handleSubmit = async () => {
    if(!isEmailValid){
      alert("Invalid Email Address")
      return;
    }
    setIsLoading(true);
    const registrantData = await getSearchUser(email);
 //console.log(registrantData)
   if (registrantData.length !== 0) {
   // console.log(registrantData[0].id)
      
   if(registrantData[0].agent){
      //console.log("Is Agent == " + registrantData[0].agent)
      //console.log("Has Agent == " + registrantData[0].assigned_agent_ids.length)
      
      const recordVisit = await setInteraction(registrantData[0].id);
        
      if(recordVisit.status === "success"){
        history.push('/thankyou');
      }

    }else{


      if(!diclosureRequirements(registrantData[0].additional_fields)){
        setProfile
        dispatch(setProfile(registrantData));
        history.push('/dr');
      }else{
        const recordVisit = await setInteraction(registrantData[0].id);
        
        if(recordVisit.status === "success"){
          history.push('/thankyou');
        }
      }


    }



    




    // const extraData = await getExtendRegistrant(
      //   registrantData.items[0].registrantId,
      //   id
      // );

      // dispatch(setPerson({ ...registrantData.items[0], ...extraData }));
      // dispatch(setEmail(registrantData.items[0].email));
      // setIsLoading(false);
      // // Phase 2 - will have to change the following line. Form is not built yet.
      // if (id.toLowerCase() === 'offices') {
      //   history.push('/offices/form');
      // } else {
      //   history.push('/form');
      // }
    } else {
      //alert("Proceed to Regi Form")
      dispatch(setEmail(email));
      setIsLoading(false);
      history.push('/pcform');
    //   // Phase 2 - will have to change the following line. Form is not built yet.
    //   if (id.toLowerCase() === 'offices') {
    //     history.push('/offices/form');
    //   } else {
    //     history.push('/form');
    //   }
   }
  };

  return (
    <Root>
      <Loading active={isLoading} />

      <Helmet meta={[
        {
          name: 'robots',
          content: 'noindex,nofollow',
        }
		]}
    />
      <Logo src={require('src/assets/images/logo.svg')} alt="logo" />
      <Title>
        <h1><span>WELCOME</span> TO<br />THE AMAZING BRENTWOOD</h1>
        <h3>Please follow the prompts below.</h3>
       </Title>
      <input
        placeholder="Type your email here"
        onChange={(e) => validateEmail(e.target.value)}
      />
     
        <StyledButton handleClick={handleSubmit} text="Proceed" />
     
    </Root>
  );
};

const Root = styled.div`
  
  display: block;
  width: 100vw;
  height:100vh;

  background-color: #fff;
  ${vw('padding-top', 190, 175, 370)}
  ${vw('padding-left', 25, 60, 100)}
  ${vw('padding-right', 25, 60, 300)} 
  ${vw('padding-bottom', 50, 75, 100)}
  
  input {
    border: 1px solid #E1E1E1;
    box-sizing: border-box;
    color: #747474;
    ${vw('width', 200,400)}
    ${vw('height', 40)}
    ${vw('font-size', 15, 18)}
    ${vw('line-height', 10, 16)}
    ${vw('letter-spacing', 0.06)}
    ${vw('padding-left', 3, 5)}
  }
  
`;

const StyledButton = styled(Button)`
display: block;
${vw('width', 150, 250, 250)}
    ${vw('margin-top', 25, 60)}
    text-align: center;
`

const Logo = styled.img`
  position:absolute;
  ${vw('top', 0, 0, 0)}
  ${vw('left', 25, 60, 100)}
  ${vw('width', 80, 126)}
  ${vw('height', 140, 221)}
  @media ${media.desktop} {
   
  }
`

const Title = styled.div`
 /* background-image: url(${require('src/assets/images/hero-extened.jpg')});
 background-size: cover;
  
  width:100vw;
  height:100vh; */
 
h1{
    font-family: Gotham Black;
  ${vw('font-size', 24, 50)}
 ${vw('padding-bottom', 10, 75, 20)}
}
h3{
  font-family: Big Caslon;
  font-weight: 500;
  ${vw('font-size', 14, 25)}
 ${vw('padding-bottom', 30, 75, 40)}
 ${vw('padding-right', 0, 60, 200)}
}
p{
    font-family: Big Caslon;
   font-style: normal;
   font-weight: normal;
   color: #000000;
   text-transform: none;
   ${vw('font-size', 14, 20)}
   ${vw('line-height', 22, 32)}
 

}
 span {
   color: #DE5647;
 }
 
  `
export default Email;
